import React from 'react';
import ToolbarDesktop from './ToolbarDesktop';
import ToolbarMobile from './ToolbarMobile';
import useMobileBreakpoints from '../../../../../../../common/src/hooks/useMobileBreakpoints';

interface Props {
  toolbarContent?: React.ReactElement;
  mobileToolbarContent?: React.ReactElement;
}

const Toolbar: React.FC<Props> = ({ toolbarContent, mobileToolbarContent }) => {
  const { isLaptop } = useMobileBreakpoints();
  const isMobile = !isLaptop;
  if (isMobile === undefined) return null;
  if (isMobile)
    return (
      <ToolbarMobile>{mobileToolbarContent || toolbarContent}</ToolbarMobile>
    );

  return <ToolbarDesktop>{toolbarContent}</ToolbarDesktop>;
};

export default Toolbar;
